<app-navigation-layout [hideHeader]="false" [hideMenu]="isGuest">
  <span header-container>
    <h3>{{ 'Thank you for your order' | translate }}</h3>
    <p *ngIf="!isGuest">{{ 'You will shortly receive an order confirmation by e-mail.' | translate }}</p>
    <p *ngIf="isGuest">{{ 'You can receive an order confirmation by e-mail.' | translate }}</p>
  </span>

  <span main-container>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <app-basket-view [order]="order" [readonly]="true"></app-basket-view>
        </div>
      </div>
    </div>
  </span>
  <span menu-container class="text-lg-left text-center">
    <app-current-partner-contact></app-current-partner-contact>
  </span>
  <span navigation-container>
    <div class="row justify-content-center">
      <div class="col-10 col-xl-12">
        <div class="row controls">
          <div *ngIf="downloadInvoiceUrl" class="col">
            <a [href]="downloadInvoiceUrl" class="download-button" target="_blank">
              <app-button [title]="'Download Invoice' | translate" [isLeftStyle]="true"></app-button>
            </a>
          </div>
          <div *ngIf="downloadTicketsUrl" class="col">
            <a [href]="downloadTicketsUrl" class="download-button" target="_blank">
              <app-button [title]="'Download Tickets' | translate" [isLeftStyle]="true"></app-button>
            </a>
          </div>
          <div *ngIf="downloadGiftCardsUrl" class="col">
            <a [href]="downloadGiftCardsUrl" class="download-button" target="_blank">
              <app-button [title]="'Download GiftCards' | translate" [isLeftStyle]="true"></app-button>
            </a>
          </div>
          <div class="col" *ngIf="isGuest">
            <form ngForm class="send-email">
              <app-input class="email-input" [title]="'E-Mail' | translate" [(ngModel)]="email" email required>
              </app-input>
              <app-button class="col" [title]="'Send' | translate" [isLeftStyle]="false" (clickEvent)="onSendByEmail()"
                [disabled]="!isFormValid"></app-button>
            </form>
          </div>
          <app-button class="col" [title]="'Continue shopping' | translate" (clickEvent)="onClickContinueShopping()">
          </app-button>
        </div>
      </div>
    </div>
  </span>
</app-navigation-layout>
